import { get_token, get_user_details } from "@/router";
import NotificationDropdown from '@/components/Notifications/Notification.vue'
import MenuSideBar from '@/components/MenuSidebar/MenuSidebar.vue'
import CreatePortal from "@/components/CreatePortal/CreatePortal.vue";
import Loader from "@/components/Loader/LoaderView";
import Swal from 'sweetalert2';
import { client_domain } from "@/main.js";


export default {
  props: {
    activeTab: String,
    portal_admin: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    NotificationDropdown,
    MenuSideBar,
    CreatePortal,
    Loader
  },

  computed: {
    isHomePage() {
      return this.$route.name === 'home'; // Assuming your home page route is named 'home'
    },
    isHomeFilterPage() {
      return this.$route.name === 'home_filter';
    },
    isAdverts() {
      return this.$route.name === 'adverts';
    },
    isPersonalProfile() {
      return this.$route.name === 'view_personal_profiles';
    },
    isPortalPage() {
      return this.$route.name === 'view_portal';
    },
    is_group_page() {
      return this.$route.name === 'view_group';
    },
    is_business_page() {
      return this.$route.name === 'view_business_profiles';
    },
    is_publish_portal() {
      return this.$route.name === 'publish_portal';
    },
    is_publish_report() {
      return this.$route.name === 'view_full_report';
    },
    // 1. Portals user is approved for
    your_portals() {
      return this.portals.filter(p =>
        p.name?.toLowerCase() !== 'default portal' &&
        p.is_public === false &&
        p.has_access === 'approved'
      );
    },

    // 2. All Public portals + any Private portals not yet approved
    other_portals() {
      return this.portals.filter(p => {
        const isDefault = p.name?.toLowerCase() === 'default portal';
        if (isDefault) return false;

        // Condition: If it's public, it goes here. 
        // OR if it's private but NOT approved, it goes here.
        return p.is_public === true || p.has_access !== 'approved';
      });
    },
    displayed_your_portals() {
      return this.show_all_your_portals
        ? this.your_portals
        : this.your_portals.slice(0, this.your_portals_visible_count);
    },
    has_more_your_portals() {
      return this.your_portals.length > this.your_portals_visible_count;
    }
  },
  mounted() {
    this.token_exists = get_token();
    this.user_details = get_user_details();
    this.fetchPortals();

    if (client_domain.includes('tdm')) {
      this.tdm_domain = true;
    }
    if (client_domain.includes('workbook')) {
      this.workbook_domain = true;
    }
    if (client_domain.includes('cbo')) {
      this.cbo_domain = true;
    }
    if (client_domain.includes('dwypd') || client_domain.includes('nsp')) {
      this.soulcity = true;
    }
    if(client_domain.includes('chiefluthuli')) {
      this.school_domain = true;
    }
    if (client_domain.includes('demo') || client_domain.includes('engagenet')) {
      this.visible_domain = true;
    }
    if (client_domain.includes('engagenet') || client_domain.includes('apex') ) {
        this.incident = true;
      }
      if (client_domain.includes('engagenet') || client_domain.includes('vettedsa')){
        this.marketplace = true;
      }
  },
 inject: ['client_features'],

  data() {
    return ({
      token_exists: false,
      user_details: {
        "user_role": '',
        "first_name": '',
        "last_name": '',
      },
      workbook_domain: false,
      school_domain: false,
      visible_domain: false,
      portals: [],
      loading: true,
      selectedPortal: null,
      cbo_domain: false,
      soulcity: false,
      tdm_domain: false,
      request_access:false,
      incident:false,
      marketplace:false,
      show_all_your_portals: false,
      your_portals_visible_count: 5
    });
  },
  methods: {
    getToken() {
      return get_token();
    },
    getInitials(name) {
        const words = name.trim().split(" ");
        return words.length === 1
          ? words[0].substring(0, 2).toUpperCase()
          : (words[0][0] + words[1][0]).toUpperCase();
      },
    toggle_your_portals() {
      this.show_all_your_portals = !this.show_all_your_portals;
    },
    fetchPortals() {
      this.token_exists = this.getToken();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_portals_api/`,
        method: 'POST',
        headers: this.token_exists
          ? {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          }
          : {},
        data: JSON.stringify(this.payload),
        success: (data) => {
          if (data.portals) {
            this.portals = data.portals.filter(
                  portal => portal.name?.toLowerCase() !== 'default portal'
                );
          } else {
            this.portals = [];
          }

          setTimeout(() => {
            this.loading = false;
          }, 1000);
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    handle_unauthenticated() {
      if (!this.token_exists) {
        this.$router.push({ name: 'sign_in_finale' });
        return false;
      }
      return true;
    },
    open_portal(portal_id, portal_name, is_public, portal_type) {

      if (portal_type?.name === 'incident') {
        this.$router.push({ name: 'view_incidents', params: { portal_id: portal_id, portal_name: portal_name, } });
      }
      else if (portal_type?.name === 'publishing') {

        this.$router.push({ name: 'publish_portal', params: { portal_id: portal_id, portal_name: portal_name, } });
      }
      else {

        this.$router.push({ name: 'view_portal', params: { portal_id: portal_id, portal_name: portal_name, is_public: is_public } });
        this.filterReports(portal_id);
      }
    },
    filterReports(portal_id) {
      this.loading = true;
      const payload = {
        filter_values: {
          portal_id: portal_id
        }
      }
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/filter_reports_api/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: (response) => {
          if (response.status === "success") {
            this.$emit('portal_selected', response.data.report_data);
          }

          setTimeout(() => {
            this.loading = false;
          }, 1000);

        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    handlePortalClick(portal) {
      if (!this.handle_unauthenticated()) {
        return;
      }
      this.is_public = portal.is_public


      if (portal.has_access == "approved") {
        this.$emit('portal_profile', portal);
        this.open_portal(portal.id, portal.name, portal.is_public, portal.portal_type);

        // this.get_portal_access_requested_users();
        $("#request_access").modal('hide');
      }

      else if (portal.has_access == "pending") {
        $("#request_access").modal('hide');
        Swal.fire({
          icon: 'info',
          title: 'Info',
          text: 'Access request already submitted.',
          showConfirmButton: false,
          timer: 3000,
          position: 'bottom-end',
          toast: true
        })
        return;
      }

      else {
        $("#request_access").modal('show');
        this.selectedPortal = portal;
        return;
      }

    },

    requestAccess() {
      const PORTAL_ID = this.selectedPortal ? this.selectedPortal.id : null;

      this.request_access = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/request_access_private_portal/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          portal_id: PORTAL_ID,
        }),
        success: (data) => {
          if (data.status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Access request submitted successfully.',
              showConfirmButton: false,
              timer: 3600,
              position: 'bottom-end',
              toast: true
            })
          }
          else {
            Swal.fire({
              icon: 'info',
              title: 'Info',
              text: 'Request Already Sent',
              showConfirmButton: false,
              timer: 3000,
              position: 'bottom-end',
              toast: true
            })
          }
        },
        complete: () => {
          this.isLoading = false;
          this.selectedPortal = null;
          this.request_access = false;
          $("#request_access").modal('hide');
        }
      });
    },
  }
}
